import React from 'react';
import classnames from 'classnames';
import config, { SLIDE, SWITCH, BACKSPACE, EYE_TYPE_TOGGLE, TEXT } from './config';
import Button from './Button';
import './index.scss';

type TdProps = {
  rowSpan?: number;
}

type keyboardRef = {
  current: any
}

type keyboardProps = {
  className?: string;
  eyeType?: string,
  unavailableKeys?: Array<any>,
  onKeyNext: () => void; 
  onKeyBackspace: () => void;
  onKeyTypeChange: (value: string) => void;
  onKeyValueChange: (value: string) => void;
}

type keyboardState = {
  maxHeight: number;
  visible: boolean;
}

const widthConfig: Array<string> = ['18.5%', '21%', '21%', '21%', '18.5%'];
export default class Keyboard extends React.Component<keyboardProps, keyboardState> {
  constructor(props: any) {
    super(props);
    // 创建div实例
    this.keyboardRef = React.createRef<keyboardRef>();
  }

  static defaultProps: keyboardProps = {
    unavailableKeys: [],
    onKeyNext() {},
    onKeyBackspace() {},
    onKeyTypeChange() {},
    onKeyValueChange() {},
  }

  state = {
    maxHeight: 1000, // 最大高度
    visible: true, // 是否显示键盘
  }

  // 键盘容器实例
  keyboardRef: keyboardRef
  // 初始化实际高度
  initMaxHeight: number = 0

  componentDidMount() {
    // 计算高度
    this.initMaxHeight = this.keyboardRef.current.offsetHeight;
    this.setState({
      maxHeight: this.initMaxHeight,
    });
  }

  /**
   * 键盘按下
   * @param type 按键类型
   * @param value 键值
   */
  // onKeyPress: <T>(type: Symbol, value: T) => void = (type, value) => {
  onKeyPress = (type: Symbol, value: any) => {
    // 如果是键盘伸缩
    switch(type) {
      case SLIDE: {
        this.onSlideToggle(value);
        break;
      }
      case SWITCH: {
        this.onNextToggle();
        break;
      };
      case BACKSPACE: {
        this.onBackspace();
        break;
      }
      case EYE_TYPE_TOGGLE: {
        this.onTypeToggle(value);
        break;
      }
      case TEXT: {
        this.onValueChange(value);
        break;
      }
      default: break;
    }
  }
  
  /**
   * 键盘输入正常值
   * @param value 值的改变
   */
  onValueChange = (value: string) => {
    this.props.onKeyValueChange(value);
  }

  /**
   * 眼别类型切换
   * @param value 眼别切换
   */
  onTypeToggle = (value: string) => {
    this.props.onKeyTypeChange(value);
  }

  /**
   * 退格删除
   */
  onBackspace = () => {
    this.props.onKeyBackspace();
  }

  /**
   * 点击键盘下一个
   */
  onNextToggle = () => {
    this.props.onKeyNext();
  }

  /**
   * 键盘伸缩
   * @param direction 键盘伸缩方向
   */
  onSlideToggle = (direction: string) => {
    const visible = direction === '1';
    // 控制显示与隐藏
    this.setState({
      maxHeight: visible ? this.initMaxHeight : 0,
      visible,
    });
  }

  render() {
    const { className, eyeType = '', unavailableKeys = [] } = this.props;
    const { maxHeight, visible } = this.state;

    return (
      <div
        className={classnames('keyboard', className)}
        ref={this.keyboardRef}
      >
        {/* 键盘收起后，展开按钮 */}
        <div
          onClick={() => this.onSlideToggle('1')}
          className={classnames('keyboard-toggle', { visible: !visible })}
        >
          <i className="icon-yincangjianpan iconfont" />
        </div>
        {/* 键盘主体 */}
        <div className="keyboard-table" style={{ maxHeight }}>
          <table>
            <tbody>
              {config.map((rowItems, i) => {
                const rowKey = `${i}`;
                return (
                  <tr key={rowKey}>
                    {Object.values(rowItems).map((item, index) => {
                      const colKey = `${index}`;
                      const TdProps: TdProps = {};
                      // 获取td宽度
                      const width = widthConfig[index];
                      // 判断是否需要合并行
                      if (item.rowSpan) {
                        TdProps.rowSpan = item.rowSpan;
                      }
                      // 是否禁用
                      const disabled = unavailableKeys.indexOf(item.value) > -1;

                      return (
                        <td
                          key={colKey}
                          style={{ width }}
                          {...TdProps}
                        >
                          <Button
                            disabled={disabled}
                            className={classnames({
                              rowspan: !!item.rowSpan,
                              small: item.size === 'small',
                              primary: item.back === 'primary',
                            }, item.color || '')}
                            type={item.type}
                            eyeType={eyeType}
                            value={item.value}
                            onKeyPress={(type, value) => this.onKeyPress(type, value)}
                          >
                            {item.value}
                          </Button>
                        </td>
                      )
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}